if (!window.__activityFormAssetsReady) {
  const assetPromises = window.__activityFormAssetPromises || (window.__activityFormAssetPromises = {});
  const assets = [
    { src: "\/\/uk.roborock.com\/cdn\/shop\/t\/15\/assets\/RoInput.js?v=9671540383312282381790576460", component: 'ro-input' },
    { src: "\/\/uk.roborock.com\/cdn\/shop\/t\/15\/assets\/RoSelect.js?v=175623534981857522281791862870", component: 'ro-select' },
    { src: "\/\/uk.roborock.com\/cdn\/shop\/t\/15\/assets\/RoChoiceChips.js?v=40010114715389572991784860150", component: 'ro-choice-chips' },
    { src: "\/\/uk.roborock.com\/cdn\/shop\/t\/15\/assets\/RoCheckbox.js?v=100657354908828662051791862869", component: 'ro-checkbox' },
    { src: "\/\/uk.roborock.com\/cdn\/shop\/t\/15\/assets\/RoTextarea.js?v=87762728768011705691791862870", component: 'ro-textarea' },
    { src: "\/\/uk.roborock.com\/cdn\/shop\/t\/15\/assets\/RoDatePicker.js?v=57345819973731936501791862869", component: 'ro-date-picker' },
    { src: "\/\/uk.roborock.com\/cdn\/shop\/t\/15\/assets\/RoFileUpload.js?v=76501023751183491881791862869", component: 'ro-file-upload' },
    { src: "\/\/uk.roborock.com\/cdn\/shop\/t\/15\/assets\/RoToast.js?v=166085325754126541784786077", component: 'ro-toast', global: 'RoToast', module: true },
  ];

  function assetReady(asset) {
    if (asset.component && (!window.customElements || !customElements.get(asset.component))) return false;
    if (asset.global && typeof window[asset.global] === 'undefined') return false;
    return true;
  }

  function findExistingScript(src) {
    const absoluteSrc = new URL(src, document.baseURI).href;
    return Array.prototype.find.call(document.scripts, (script) => script.src === absoluteSrc);
  }

  function waitForScript(script, asset, resolve, reject) {
    const timeout = window.setTimeout(
      () => reject(new Error(`Timed out loading resource: ${asset.src}`)),
      15000,
    );
    script.addEventListener(
      'load',
      () => {
        window.clearTimeout(timeout);
        if (assetReady(asset)) resolve();
        else reject(new Error(`Resource loaded but component is unavailable: ${asset.src}`));
      },
      { once: true },
    );
    script.addEventListener(
      'error',
      () => {
        window.clearTimeout(timeout);
        reject(new Error(`Failed to load resource: ${asset.src}`));
      },
      { once: true },
    );
  }

  function loadAssetOnce(asset) {
    if (assetReady(asset)) return Promise.resolve();
    if (assetPromises[asset.src]) return assetPromises[asset.src];

    assetPromises[asset.src] = new Promise((resolve, reject) => {
      const existing = findExistingScript(asset.src);
      if (existing) {
        waitForScript(existing, asset, resolve, reject);
        return;
      }

      const script = document.createElement('script');
      script.src = asset.src;
      script.setAttribute('data-activity-form-asset', '');
      if (asset.module) script.type = 'module';
      else script.async = false;
      waitForScript(script, asset, resolve, reject);
      document.head.appendChild(script);
    });
    return assetPromises[asset.src];
  }

  window.__activityFormLoadAssetOnce = loadAssetOnce;
  window.__activityFormHeicAsset = {
    src: "\/\/uk.roborock.com\/cdn\/shop\/t\/15\/assets\/heic2any.min.js?v=90383926560294506831739184246",
    global: 'heic2any',
  };
  window.__activityFormAssetsReady = Promise.all(assets.map(loadAssetOnce));
}
